import { utc } from "moment";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";

import { useCalendarContext } from "../../../context/calendar_context";
import { useCalendarHeader } from "../use_calendar_header";
import { WeekItem } from "./week_item/week_item";
import css from "./weeks.module.scss";
import { WEEK_DAYS_COUNT } from "./weeks.utils";

const getFistWeekDays = (date: string): number => {
  const weekDay = utc(date).weekday();
  const startWeekDays = WEEK_DAYS_COUNT - weekDay;
  if (startWeekDays < WEEK_DAYS_COUNT) {
    return startWeekDays;
  }
  return 0;
};

type WeeksProps = {
  startDate: string;
  daysCount: number;
};

export const Weeks = ({ startDate, daysCount }: WeeksProps): JSX.Element => {
  const { dayWidth, zoomMode } = useCalendarContext();
  const { weeksHeight } = useCalendarHeader();
  const { formatISODate } = useDateFormatter();

  const weekItems = useMemo(() => {
    const firsWeekDaysCount = getFistWeekDays(startDate);
    const firstWeekWidth = firsWeekDaysCount * dayWidth;

    const lastWeekDaysCount = (daysCount - firsWeekDaysCount) % WEEK_DAYS_COUNT;

    const fullWeeksCount = (daysCount - firsWeekDaysCount - lastWeekDaysCount) / WEEK_DAYS_COUNT;
    const fullWeeksStartDate = utc(startDate).add(firsWeekDaysCount, "days");
    return [...Array(Math.floor(fullWeeksCount))].map((_, weekNumber) => {
      const currentWeekStartDate = fullWeeksStartDate.clone().add(weekNumber, "weeks");
      const weekStartDate = formatISODate(currentWeekStartDate);

      return (
        <WeekItem
          key={`week_${weekStartDate}`}
          startDate={weekStartDate}
          startOffset={firstWeekWidth}
          fullWeeksCount={fullWeeksCount}
          weekNumber={weekNumber}
          dayWidth={dayWidth}
          zoomMode={zoomMode}
        />
      );
    });
  }, [startDate, daysCount, dayWidth, zoomMode]);

  return (
    <div className={css.root} style={{ height: weeksHeight }}>
      {weekItems}
    </div>
  );
};
